import React from 'react'
import Highlighter from 'react-highlight-words'
import { Table, Divider, Input, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { messageTypes } from '../../../../actions/messages'

class StyledChallengeTableSettings extends React.Component {
  state = {
    columns: []
  }

  settings = {
    bordered: false,
    loading: false,
    pagination: { position: 'bottom' },
    size: 'default',
    showHeader: true
  }

  getColumnSearchProps = (dataIndex, language) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node }}
          placeholder={messageTypes[language]['table_search_' + dataIndex]}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size='small'
          style={{ width: 90, marginRight: 8 }}
        >
          {messageTypes[language].search}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size='small'
          style={{ width: 90 }}
        >
          {messageTypes[language].clear}
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined className={filtered ? 'active' : ''} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
    )
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm()
    this.setState({ searchText: selectedKeys[0] })
  }

  handleReset = (clearFilters) => {
    clearFilters()
    this.setState({ searchText: '' })
  }

  setColumns (language) {
    this.setState({
      columns: [{
        title: messageTypes[language].name_name,
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => { return a.name.localeCompare(b.name) },
        sortDirections: ['ascend', 'descend'],
        ...this.getColumnSearchProps('name', language)
      }, {
        title: messageTypes[language].challenge_level,
        dataIndex: 'level',
        key: 'level',
        sorter: (a, b) => { return a.level - b.level },
        render: (level) => {
          return level && <img style={{ height: '14px' }} src={'/images/icons/' + level + 'stars_clean.svg'} alt={level} />
        }
      }, {
        title: messageTypes[language].category,
        dataIndex: 'challenge_category',
        key: 'challenge_category',
        sorter: (a, b) => { return a.challenge_category.localeCompare(b.challenge_category) },
        sortDirections: ['ascend', 'descend'],
        ...this.getColumnSearchProps('challenge_category', language)
      }, {
        title: messageTypes[language].order,
        dataIndex: 'rorder',
        key: 'rorder',
        sorter: (a, b) => { return a.rorder - b.rorder }
      }, {
        title: messageTypes[language].stack_type,
        dataIndex: 'stack_type',
        key: 'stack_type',
        sorter: (a, b) => { return (!a.stack_type && 1) || a.stack_type.localeCompare(b.stack_type) },
        sortDirections: ['ascend', 'descend'],
        ...this.getColumnSearchProps('stack_type', language)
      }, {
        title: messageTypes[language].active2,
        dataIndex: 'active_icon',
        key: 'active_icon',
        sorter: (a, b) => { return a.active - b.active }
      }, {
        title: messageTypes[language].added_to_map,
        dataIndex: 'added_to_map_icon',
        key: 'added_to_map_icon',
        sorter: (a, b) => { return a.added_to_map - b.added_to_map }
      }, {
        title: messageTypes[language].publication_time,
        dataIndex: 'publication_time',
        key: 'publication_time',
        sorter: (a, b) => {
          const r = (typeof a.publication_time).localeCompare(typeof b.publication_time)
          if (r === 0) {
            if (typeof a.publication_time === 'string') {
              return a.publication_time.localeCompare(b.publication_time)
            } else {
              return a.publication_time - b.publication_time
            }
          }

          return r > 0 ? -1 : 1
        },
        render: (text, record) => {
          return (typeof text === 'object' && text.format('YYYY-MM-DD HH:mm:ss')) || text
        }
      }, {
        title: messageTypes[language].solve_time_limit2,
        dataIndex: 'solve_end_date',
        key: 'solve_end_date',
        sorter: (a, b) => {
          const r = (typeof a.solve_end_date).localeCompare(typeof b.solve_end_date)
          if (r === 0) {
            if (typeof a.solve_end_date === 'string') {
              return a.solve_end_date.localeCompare(b.solve_end_date) > 0 ? -1 : 1
            } else {
              return a.solve_end_date - b.solve_end_date
            }
          }

          return r
        },
        render: (text, record) => {
          return (typeof text === 'object' && text.format('YYYY-MM-DD HH:mm:ss')) || text
        }
      }, {
        title: messageTypes[language].actions,
        key: 'action',
        render: (text, record) => (
          <span>
            <a href='#show-details' className='show-btn' onClick={() => { this.props.setShowDataId(record._id) }}>{messageTypes[language].show}</a>
            <Divider type='vertical' />
            <a href='#edit-challenge' className='edit-btn' onClick={() => { this.props.setDataId(record._id) }}>{messageTypes[language].edit}</a>
            <Divider type='vertical' />
            <a href='#delete-challenge' className='delete-btn' onClick={() => { this.props.deleteRecord(record._id) }}>{messageTypes[language].delete}</a>
          </span>
        )
      }]
    })
  }

  componentDidMount () {
    const { language } = this.props
    this._isMounted = true
    this.setColumns(language)
  }

  componentDidUpdate (prevProps, prevState) {
    const { language } = this.props
    if (this._isMounted && language !== prevProps.language) {
      this.setColumns(language)
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  render () {
    const { columns } = this.state
    const { data, language } = this.props

    return (
      <Table
        className={`settings-table ${data && data.length ? 'fade-in' : ''}`}
        {...this.settings}
        columns={columns}
        dataSource={data}
        locale={{
          triggerDesc: messageTypes[language].table_sort_desc,
          triggerAsc: messageTypes[language].table_sort_asc,
          cancelSort: messageTypes[language].table_sort_cancel
        }}
      />
    )
  }
}

export default StyledChallengeTableSettings
